import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { URL_BASE } from '../../constants/api_urls';
import axios from 'axios';
import {
  CircularProgress,
  Typography,
  Grid,
  Container
} from '@material-ui/core';
import Logo from '../../assets/Trazer/logo_azul.svg';
import BottomLinks from './BottomLinks';
import bottomLogo from '../../assets/signeblock1.png';
import SearchBar from './SearchBar';
import SearchNav from './SearchNav';
import NotFoundResult from './NotFoundResult';
import { useWindowSize } from '../../customHooks/useWindowSize';
import SuccessResult from './SuccessResult';
import SuccessAssetsHistoryResult from './SuccessAssetsHistoryResult';
import { withRouter } from 'react-router-dom';
import i18next from 'i18next';
import moment from 'moment';
import SuccessContractResult from './SuccessContractResult';
import translate from '../../i18next/funcTranslateHelper';
import ChangeLanguage from '../ChangeLanguage/ChangeLanguage';
import trackingUserInfo from '../../customHooks/trackingUserInfo';

const URL_STATIC_RESOURCES = process.env.REACT_APP_STATIC_RESOURCES_URL;

export const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  mainContainer: {
    minHeight: '100%',
    padding: 0,
    [theme.breakpoints.up('md')]: {
      maxWidth: 1140,
      paddingLeft: 31.5,
      paddingRight: 31.5
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: 1140,
      paddingLeft: 31.5,
      paddingRight: 31.5
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: 1140,
      paddingLeft: 15,
      paddingRight: 15
    }
  },
  mainGrid: {
    minHeight: '100%'
  },
  topItemContainerGrid: {
    position: 'relative'
  },
  itemHeader: {
    padding: 0,
    display: 'flex'
  },
  headerBrand: {
    width: 119,
    minWidth: 119,
    [theme.breakpoints.down('md')]: {
      padding: 0,
      paddingTop: 42
    },
    [theme.breakpoints.down('xs')]: {
      padding: 0,
      paddingTop: 24
    },
    [theme.breakpoints.up('md')]: {
      padding: 0,
      paddingTop: 42
    }
  },
  mainContainerTopItem: {
    width: '100%',
    padding: 0,
    alignItems: 'flex-start'
  },
  mainContainerTopItemContent: {
    width: '100%',
    paddingTop: 30,
    [theme.breakpoints.up('md')]: {
      maxWidth: 944
    }
  },
  resultContainer: {
    maxWidth: 1075
  },
  matchedItemsText: {
    fontFamily: 'Roboto-Light',
    fontSize: 20,
    color: '#404040',
    letterSpacing: 0,
    marginBottom: 16,
    [theme.breakpoints.up(600)]: {
      marginTop: 59
    },
    [theme.breakpoints.down(600)]: {
      marginTop: 38
    }
  },
  mainCardContent: {
    [theme.breakpoints.up(600)]: {
      marginTop: 59
    },
    [theme.breakpoints.down(600)]: {
      marginTop: 38
    }
  },
  bottomItemContainerGrid: {
    [theme.breakpoints.down(785)]: {
      marginTop: 20
    },
    [theme.breakpoints.up(785)]: {
      marginTop: 32
    }
  },
  cardText: {
    textAlign: 'center'
  }
}));

function isEmpty (obj) {
  for (var prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) return false;
  }

  return true;
}

const HashResult = props => {
  const classes = useStyles();
  const size = useWindowSize();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [found, setFound] = useState(false);
  const [hashType, setHashType] = useState(props.location.pathname.split('/')[2]);
  const [hashPlaceholder, setHashPlaceholder] = useState('Upload your hash or file');
  const [uploadingFile, setUploadingFile] = useState(false);
  const lang = navigator.language || navigator.userLanguage || 'es';

  const locationSearch = props.location.search;

  const propKey = props.match.params.key;
  const propType = props.match.params.type;

  const giveMePlaceholder = (route) => {
    let type;
    switch (route) {
      case 'identity':
        type = translate('Trazer:searchBarPlaceholder:identity');
        break;
      case 'contract':
        type = translate('Trazer:searchBarPlaceholder:contract');
        break;
      case 'asset':
        type = translate('Trazer:searchBarPlaceholder:asset');
        break;
      case 'hash':
        type = translate('Trazer:searchBarPlaceholder:hash');
        break;
      default:
        type = translate('Trazer:searchBarPlaceholder:default');
        break;
    }
    return type;
  };

  useEffect(() => {
    setHashType(props.location.pathname.split('/')[2]);
    setHashPlaceholder(giveMePlaceholder(props.location.pathname.split('/')[2]));
    // eslint-disable-next-line
  }, [props]);

  useEffect(
    function () {
      submitHash(propKey, propType, locationSearch);
    },
    // eslint-disable-next-line
    [propKey,propType, locationSearch]
  );

  useEffect(() => {
    if (Object.keys(data).length) {
      if (data.appData && data.appData.trackingInfo) {
        trackingUserInfo({ data });
      }
    }
  }, [data]);

  const getTemplateHtml = async (path) => {
    let templateResponse;
    try {
      templateResponse = await axios({ url: `${URL_STATIC_RESOURCES}/gouze/templates/${path}` });
    } catch (e) {
      console.error(e);
    }
    if (!templateResponse || !templateResponse.data.includes('{{#data}}')) {
      try {
        templateResponse = await axios({ url: `${process.env.PUBLIC_URL}/templates/${path}` });
      } catch (e) {
        console.error(e);
      }
    }

    return templateResponse;
  };

  const handleChange = (event, newValue) => {
    setHashType(newValue);
    setHashPlaceholder(giveMePlaceholder(newValue));
  };

  const submitHash = async (hash, type, locationSearch) => {
    setLoading(true);

    let url;
    switch (type) {
      case 'transaction':
        url = `${URL_BASE}/tx/${hash}`;
        break;
      case 'asset':
        /* eslint-disable */
        const transform = {
          '2011344.AF02': '37d3cfb3ff33168236ce0ef89935bc541f0bb80884a9a3ac005fde71b9dea929',
          '2011345.AF02': '9ae8337119df5f50633b82a9efdae505592cf42ed1f86187e2ffb966d435f567',
          '2011346.AF02': '294222c0d8ab8ddf27d1ed11d161e980042e9f1387df9f9d1ea0e1973fc75a16',
          '2011347.AF02': '749fee314fbd6ec4123b0e03a2c9ddcf5d7c40b5bd8aa5c6d9e9c5492e025790',
          '2011348.AF02': 'f127d03e4158209c1b7f0d0632ddcd7f38a31e30361b2a0bffbe633280f6efea',
          '2011349.AF02': '25a5eea34772d869044ec95bb307606ef1bb39863f7a54c5a86d66ce8c2b366d',
          '2011350.AF02': '75a9a0982f3b0969edab57a5b74b59273a4195ade2929b5d8e1266e6f898323a',
          '2011351.AF02': '298e80b91c543b5db37071b4c8536a612ed37d0b16770287ca29213b70880757',
          '2011352.AF02': 'aa6164629abed743a20580cec6e8ccbb2c3a8cd0e42ec0ad54065852b7adcbc8',
          '2011353.AF02': 'e97fe32f1980dc98eb4eefde725c5cdae9f541b86be50267fdf05115381e8f7c',
          '2011354.AF02': '47757b8ed793ee8ee8a6f7293248054a92de3129a9713671720b46f4f079cf2b'
        };
        const transformed = transform[hash];
        url = `${URL_BASE}/open/history/asset/${transformed || hash}`;
        /* eslint-enable */
        break;
      case 'contract':
        url = `${URL_BASE}/open/history/contract/${hash}?extendedInfo=true`;
        break;
      default:
        url = `${URL_BASE}/open/${type}/${hash}`;
        break;
    }
    url += locationSearch;
    try {
      const apiResponse = await axios({ url });
      const result = { ...apiResponse.data };
      if (type === 'asset') {
        try {
          const assetType = apiResponse.data.data[0].assetType || 'generic';
          const templateName = apiResponse.data.appData.name;
          await i18next.loadNamespaces(templateName);
          i18next.setDefaultNamespace(templateName);
          let templateResponse = await getTemplateHtml(`history/${templateName}/${assetType}.html`);
          if (!templateResponse || !templateResponse.data.includes('{{#data}}')) {
            templateResponse = await getTemplateHtml(`history/generic-${lang.substr(0, 2)}.html`);
            if (!templateResponse || !templateResponse.data.includes('{{#data}}')) {
              templateResponse = await getTemplateHtml('history/generic.html');
            }
          }
          result.template = templateResponse.data;
        } catch (e) {
          console.log(e);
        }
      }
      setLoading(false);
      setFound(true);
      setData(result);
    } catch (e) {
      setLoading(false);
      setFound(false);
    }
  };
  if (loading) {
    return (
      <div
        style={{
          height: '100%',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <CircularProgress size={60} />
      </div>
    );
  }
  return (
    <div className={classes.root} style={{ overflow: 'auto', display: 'flex' }}>
      <ChangeLanguage />
      <Container className={classes.mainContainer}>
        <Grid
          container
          direction='column'
          justify='space-between'
          className={classes.mainGrid}
        >
          <Grid
            container
            direction='row'
            justify='flex-start'
            alignItems='flex-start'
            className={classes.topItemContainerGrid}
          >
            <Grid item xs={2} className={classes.itemHeader}>
              <img
                src={Logo}
                alt='Logo gouze'
                className={classes.headerBrand}
              />
            </Grid>
            <Grid
              container
              item
              direction='column'
              alignItems='flex-start'
              className={classes.mainContainerTopItem}
            >
              <Grid item className={classes.mainContainerTopItemContent}>
                <Grid item className={classes.itemHeroSearchBar}>

                  <SearchBar
                    uploadingFile={uploadingFile}
                    setUploadingFile={status => setUploadingFile(status)}
                    hashType={hashType}
                    setHashType={name => setHashType(name)}
                    hashPlaceholder={hashPlaceholder}
                    setHashPlaceholder={name => setHashPlaceholder(name)}
                    origin='result'
                  />
                  <SearchNav
                    hashType={hashType}
                    hashPlaceholder={hashPlaceholder}
                    handleChange={handleChange}
                    origin='result'
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid container item xs={12} className={classes.resultContainer}>
              <Grid
                container
                item
                xs={12}
                justify='space-between'
                direction='row'
                className={classes.mainCardContent}
              >
                {!found && <NotFoundResult />}
                {found &&
                  !isEmpty(data) &&
                  props.match.params.type === 'asset' &&
                    <SuccessAssetsHistoryResult
                      itemType={props.match.params.type}
                      data={data}
                      date={moment.utc().format('YYYY/MM/DD HH:mm:ss')}
                    />}
                {found &&
                  !isEmpty(data) &&
                  props.match.params.type !== 'contract' && props.match.params.type !== 'asset' &&
                    <SuccessResult
                      data={data}
                      itemKey={props.match.params.key}
                      itemType={props.match.params.type}
                      date={moment.utc().format('YYYY/MM/DD HH:mm:ss')}
                    />}

                {found &&
                  !isEmpty(data) &&
                  props.match.params.type === 'contract' &&
                    <SuccessContractResult
                      data={data}
                      itemKey={props.match.params.key}
                      itemType={props.match.params.type}
                      date={moment.utc().format('YYYY/MM/DD HH:mm:ss')}
                    />}

              </Grid>
            </Grid>
          </Grid>

          {/* ------------- BOTTOMLINKS GRID COMPONENT ----------------- */}
          <Grid
            className={classes.bottomItemContainerGrid}
            container
            item
            direction='row'
            justify='space-between'
            alignItems={size.width > 785 ? 'flex-end' : 'center'}
          >
            <Grid item>
              <BottomLinks textColor='#000000' />
            </Grid>
            <Grid item>
              <div
                style={{
                  background: 'transparent'
                }}
              >
                <Grid
                  container
                  justify='space-between'
                  direction='column'
                  alignItems='center'
                  style={{ height: '100%' }}
                >
                  <Grid item>
                    <Typography
                      style={{
                        fontFamily: 'Roboto-Medium',
                        fontSize: 14,
                        color: '#565656',
                        letterSpacing: 0,
                        textAlign: 'center'
                      }}
                    >
                      A tool powered by:
                    </Typography>
                  </Grid>
                  <Grid item>
                    <img
                      src={bottomLogo}
                      alt='Logo de signeblock'
                      height={27}
                      width={129}
                      style={{ marginTop: 11 }}
                    />
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default withRouter(HashResult);
